<template>
  <BaseHoliday />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
